export default __webpack_public_path__ + "assets/a95acb.svg";